import { useLocation, useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, Container } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Navbar from "./Navbar";
import Footer from "./Footer";

function SuccessfulPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const ticketInfo = location.state?.ticketInfo || {};

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Container maxWidth="sm" dir="rtl" component="main" sx={{ flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          role="article"
          sx={{
            p: 4,
            borderRadius: "12px",
            textAlign: "center",
            width: "100%",
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 64,
              color: "#4CAF50",
              mb: 2,
            }}
          />
          <Typography
            variant="h5"
            component="h1"
            sx={{
              mb: 2,
              fontFamily: "Rubik, sans-serif",
              fontWeight: 500,
            }}
          >
            הקריאה נפתחה בהצלחה!
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            אישור פתיחת קריאה נשלח אליך בדוא"ל.
          </Typography>

          <Box sx={{ mb: 3, textAlign: "left" }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>שם:</strong> {ticketInfo?.name}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>סוג קריאה:</strong> {ticketInfo?.type}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>דחיפות:</strong> {ticketInfo?.urgency}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>מספר סידורי:</strong> {ticketInfo?.serialNumber}
            </Typography>
            {ticketInfo.ticketResponse && (
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>מספר קריאה:</strong>{" "}
                {ticketInfo?.ticketResponse?.DOCNO || "N/A"}
              </Typography>
            )}
          </Box>

          {/* <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              variant="outlined"
              onClick={() => window.print()}
              sx={{
                borderRadius: "8px",
                padding: "8px 24px",
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
                borderColor: "#006699",
                color: "#006699",
                "&:hover": {
                  borderColor: "#005588",
                  backgroundColor: "rgba(0,102,153,0.04)",
                },
              }}
            >
              הדפס אישור
            </Button>
          </Box> */}
        </Paper>
      </Box>
      </Container>
      <Footer />
    </Box>
  );
}

export default SuccessfulPage;
